import * as THREE from 'three';

import { profiler } from './perf';

export interface PerfPanelDeps {
  renderer: THREE.WebGLRenderer;
}

export interface PerfPanelHandle {
  /** Repaint the DEV perf rows; self-throttles to one paint per ~500 ms. */
  update(): void;
  dispose(): void;
}

export function createPerfPanel(deps: PerfPanelDeps): PerfPanelHandle {
  // ---------- Perf detail panel (lives in the DEV cluster) ----------
  const elPerfDetail = document.getElementById('perf-detail');
  let lastPerfPaintMs = 0;

  function updatePerfPanel(): void {
    if (!elPerfDetail) return;
    const now = performance.now();
    // Refresh display once per ~500ms (the rolling window already averages
    // 1 s worth of samples; repainting more often just churns DOM).
    if (now - lastPerfPaintMs < 500) return;
    lastPerfPaintMs = now;
    const stats = profiler.getStats();
    if (stats.frames === 0) return;
    const info = deps.renderer.info;
    // Sort sections by cost, descending — biggest hog at top
    const sections = Object.entries(stats.perSection)
      .filter(([k]) => k !== 'frame')
      .sort((a, b) => b[1] - a[1]);
    const rows: string[] = [];
    for (const [k, v] of sections) {
      const cls = v > 6 ? ' bad' : v > 3 ? ' warn' : '';
      rows.push(`<div class="perf-detail-row${cls}"><span>${k}</span><span>${v.toFixed(2)} ms</span></div>`);
    }
    elPerfDetail.innerHTML = `
      <div class="perf-detail-row total"><span>frame total</span><span>${stats.totalMs.toFixed(2)} ms</span></div>
      ${rows.join('')}
      <div class="perf-detail-gl">
        <span>draws ${info.render.calls}</span>
        <span>tris ${(info.render.triangles / 1000).toFixed(1)}k</span>
        <span>geos ${info.memory.geometries}</span>
        <span>tex ${info.memory.textures}</span>
      </div>
    `;
  }

  return {
    update: updatePerfPanel,
    dispose: () => { if (elPerfDetail) elPerfDetail.innerHTML = ''; },
  };
}
